/**
 * ProseMirror discards attributes its schema does not declare, so the block
 * handles the renderer emits have to be registered here or they vanish the
 * moment TipTap parses the HTML.
 */
import { Extension } from '@tiptap/core';

export const BLOCK_ATTRIBUTES = [
  'data-block-key',
  'data-block-type',
  'data-role',
  'data-parent',
  'data-label',
  'data-part',
] as const;

/** Node types that can carry a block handle. */
const TARGET_TYPES = [
  'paragraph',
  'heading',
  'blockquote',
  'codeBlock',
  'bulletList',
  'orderedList',
  'listItem',
  'horizontalRule',
  'image',
  'table',
  'mathBlock',
];

export const BlockAttributes = Extension.create({
  name: 'blockAttributes',

  addGlobalAttributes() {
    return [
      {
        types: TARGET_TYPES,
        attributes: Object.fromEntries(
          BLOCK_ATTRIBUTES.map((name) => [
            name,
            {
              default: null,
              parseHTML: (element: HTMLElement) => element.getAttribute(name),
              renderHTML: (attributes: Record<string, unknown>) => {
                const value = attributes[name];

                return value ? { [name]: value } : {};
              },
            },
          ])
        ),
      },
    ];
  },
});
